export interface SessionExpiredDetail {
  redirectPath: string;
}

declare global {
  interface WindowEventMap {
    'auth:sessionExpired': CustomEvent<SessionExpiredDetail>;
  }
}

export function dispatchSessionExpired(redirectPath: string): void {
  window.dispatchEvent(
    new CustomEvent<SessionExpiredDetail>('auth:sessionExpired', {
      detail: { redirectPath },
    })
  );
}
